import React from 'react';
import { Snackbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { connect } from 'react-redux';
import { closeSnackBar } from 'store/actions';
import { withStyles } from '@material-ui/core/styles';
import { amber } from '@material-ui/core/colors';

const style = (theme) => ({
    root: { color: 'white !important', paddingRight: 10 },

    success: {
        background: '#5E9331 !important'
    },
    error: {
        backgroundColor: `${theme.palette.error.dark} !important`
    },
    info: {
        backgroundColor: theme.palette.primary.dark
    },
    warning: {
        backgroundColor: amber[700]
    }
});

const TSnackbar = (props) => {
    const { classes, open, closeSnackBar, variant, message } = props;

    return (
        <Snackbar
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            open={open}
            onClose={() => {
                closeSnackBar();
            }}
            autoHideDuration={4000}
            ContentProps={{
                'aria-describedby': 'message-id',
                classes: { root: classes[variant] }
            }}
            message={
                <span id="message-id">
                    <i className={cs('fas fa-check-circle', classes[variant], classes.root)} />
                    {message}
                </span>
            }
        />
    );
};

const mapStateToProps = (state) => ({
    open: state.accounts.snackBarOptions.showSnackbar,
    variant: state.accounts.snackBarOptions.variant,
    message: state.accounts.snackBarOptions.message
});

TSnackbar.propTypes = {
    closeSnackBar: PropTypes.func.isRequired
};

export default connect(mapStateToProps, { closeSnackBar })(withStyles(style)(TSnackbar));
